/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type CmsIcon, CmsIconSchema } from './icon'

/* TypeScript */
export type ReassuranceItem = {
  id: string
  title: string
  description?: Maybe<string>
  icon: CmsIcon['icon']
  iconAppearance?: Maybe<CmsIcon>
  link?: Maybe<ContentLink>
  linkPosition?: Maybe<'title' | 'description'>
}

export type ReassuranceTheme = 'gray' | 'white' | 'yellow' | 'purple'

export type ReassuranceApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
  blocks: ReassuranceItem[]
  mobileScreenCols?: Maybe<number>
  hasBackground?: Maybe<boolean>
  theme?: Maybe<ReassuranceTheme>
}

/* Schemas */
export const ReassuranceItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.nullish(z.string()),
  icon: CmsIconSchema.shape.icon,
  iconAppearance: z.nullish(CmsIconSchema),
  link: z.nullish(ContentLinkSchema),
  linkPosition: z.nullish(z.enum(['title', 'description'])),
})

export const ReassuranceThemeSchema = z.enum([
  'gray',
  'white',
  'yellow',
  'purple',
])

export const ReassuranceApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  blocks: z.array(ReassuranceItemSchema),
  mobileScreenCols: z.nullish(z.number()),
  hasBackground: z.nullish(z.boolean()),
  theme: z.nullish(ReassuranceThemeSchema),
})

/* Schemas validation */
type TestReassuranceProps = ExpectTrue<
  Equal<ReassuranceApiProps, z.infer<typeof ReassuranceApiPropsSchema>>
>
